import { render } from "./EditNoteView.vue?vue&type=template&id=875bb720"
import script from "./EditNoteView.vue?vue&type=script&lang=js"
export * from "./EditNoteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__